function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Capa_1",
  "data-name": "Capa 1"
}, React.createElement("path", {
  id: "Group_3545",
  "data-name": "Group 3545",
  d: "M6.168,16.34H11.8a.82.82,0,0,1,.82.82h0a.82.82,0,0,1-.82.82H6.168a.82.82,0,0,1-.82-.82h0A.82.82,0,0,1,6.168,16.34ZM15,15H3a3.008,3.008,0,0,1-3-3V3A3,3,0,0,1,3,0H15a3,3,0,0,1,3,3v9a3,3,0,0,1-3,3ZM7.7,4.105a.7.7,0,0,0-.7.7v5.385a.7.7,0,0,0,.7.7.74.74,0,0,0,.388-.119l4.038-2.7a.7.7,0,0,0,0-1.164L8.088,4.217A.7.7,0,0,0,7.7,4.107Z",
  fill: "#fff"
}));

var SvgPlayer = function SvgPlayer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Lag_2",
    "data-name": "Lag 2",
    width: 18,
    height: 17.98,
    viewBox: "0 0 18 17.98",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlayer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/player.6ac354b9.svg";
export { ForwardRef as ReactComponent };